import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { type PartialDeep } from 'type-fest';

import { type CanvasElementFrom } from '@blaze-runtime/engine-domain';

import { type DefinitionMapper } from '../../../ai';

import { type ImageDefinition } from './image.definition';

export class ImageDefinitionMapper implements DefinitionMapper<'image'> {
  private readonly store = inject(Store);

  readonly type = 'image';

  extract(element: CanvasElementFrom<'image'>): PartialDeep<ImageDefinition> {
    // const content = element.props.content;

    // const theme = syncSelect(this.store, themesSelectors.getAppliedTheme);
    //
    // let imageUrl = content.imageSource?.url ?? content.imageSource?.placeholder?.fileName;
    //
    // if (imageUrl?.startsWith('$t.') && theme?.value) {
    //   const placeholder = imageUrl.replace('$t.', '') as keyof AppThemeValue;
    //   imageUrl = `${window.location.origin}/${PLACEHOLDERS_PATH}/${theme.value[placeholder] as string}`;
    // }

    return {
      comment: (element as CanvasElementFrom<'image'> & { comment: string }).comment,
      // imageUrl,
      // imageBehavior:
      //   content.options?.behavior === 'contain' ? ImageBehavior.Cover : ImageBehavior.Fit,
    };
  }
}
